import { render, staticRenderFns } from "./PostesMetiers.vue?vue&type=template&id=6c76cbf7&"
import script from "./PostesMetiers.vue?vue&type=script&lang=js&"
export * from "./PostesMetiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports